import  * as React from "react";
import { observer } from "mobx-react";
import { IDispersionDotProps} from "./IDispersionDotProps";

@observer
export class DispersionDot extends React.Component<IDispersionDotProps> {
    constructor(props: IDispersionDotProps) {
        super(props, undefined);
    }

    render() {
        let notHighlghttedProps = {className: this.props.className};
        if (!this.props.highlighted) {
            notHighlghttedProps = (({ stroke: "#fff", strokeWidth: 1 }) as any);
        }
        return <circle {...notHighlghttedProps} cx={this.props.cx} cy={this.props.cy} r="7" fill={this.props.dotColor} onClick={this.props.onDotClick} ></circle>;
    }
}